<template>
  <div class="page-outbox">
  	<!--搜索框-->
  	<div class="search-group-wapper">
  		<search-block @searchSub='searchSub' ref="searchBlock"></search-block>
  	</div>
    <!--列表-->
    <div class="list-wapper">
    	<scroll :listen-scroll="listenScroll"
	            :probe-type="probeType"
	            :data="data"
	            :pullup="true"
	            class="listview"
	            ref="listview">
	      <ul class="query-list">
	        <!--<div class="pullDown">{{pullDownMsg}}</div>-->
	        <li class="list-item" v-for="(item,index) in data" ref="listGroup" @click="selectInvoiceItem(item)">
	        	<i class="mint-checkbox-core" :class="{'checked':item.isSelected}" v-if="$route.params.isSelect=='true'"></i>
	        	<div>
	        		<i class="invoice-type-icon">{{['','普','专'][item.ci_type]}}</i>
	        		<h3 class="invoice-info-item">
	        			<label class="value"><span class="name">抬头：</span>{{item.ci_title}}</label>
	        			<label class="value"><span class="name">税号：</span>{{item.ci_vatno}}</label>
	        		</h3>
	        		<h3 class="invoice-info-item" v-if="item.ci_type=='2'">
                <label class="value"><span class="name">银行：</span>{{item.ci_bank}}</label>
                <label class="value"><span class="name">账号：</span>{{item.ci_bknum}}</label>
	        		</h3>
	        		<h3 class="invoice-info-item" v-if="item.ci_type=='2'">
                <label class="value"><span class="name">地址：</span>{{item.ci_addr}}</label>
                <label class="value"><span class="name">电话：</span>{{item.ci_phone}}</label>
	        		</h3>
		        	<div class="opr-bar">
		        		<p class="set-default-group" :class="{'active':item.ci_if_default=='1'}" v-show="$route.params.isSelect!='true'"
		        			 @click.stop="setDefault(item)"><i class="mint-checkbox-core" :class="{'checked':item.ci_if_default=='1'}"></i>
		        			{{item.ci_if_default=='1'?'默认值':'设为默认值'}}</p>
		        		<p class="set-default-group" :class="{'active':item.ci_if_default=='1'}" v-show="$route.params.isSelect=='true'">
		        			{{item.ci_if_default=='1'?'默认值':''}}
		        		</p>
		        		<p class="opr-btns">
		        			<a href="javascript:void(0);" class="opr-btn edit" @click.stop="editInvoice(item)"></a>
		        			<a href="javascript:void(0);" class="opr-btn delete" @click.stop="deleteInvoice(item)"></a>
		        		</p>
		        	</div>
	        	</div>

	        </li>
	        <div class="add-group" style="padding:.2rem;">
	        	<mt-button size="large" type="danger" @click="newInvoice">新增</mt-button>
	        </div>
	        <!--<div class="pullUp">{{pullUpMsg}}</div>-->
	      </ul>
	    </scroll>
    </div>
  </div>
</template>

<script>
  import Scroll from 'basic/scroll/scroll'
  import GoodsItem from 'basic/goodsItem/goodsItem'
  import SearchBlock from 'basic/searchBlock/searchBlock'
	export default {
    name: 'invoiceList',
    data () {
      return {
      	keyWord:'',
      	curPage: 1,
      	pageSize:10,
        data: [],
        pullDownMsg: "下拉刷新",
        pullUpMsg: "上拉加载",
        maxY: 0,
        hasMore:true,
        listenScroll:true,
        probeType:3
      }
    },
    mounted(){
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}
			this.keyWord=this.$route.params.keyword;
			this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
			this.probeType = 3;
      this.listenScroll = true;
      this.touch = {};

      this._getData(true);
    },
    methods:{
    	selectInvoiceItem(item){
    		if(this.$route.params.isSelect=='true'){
    			//选择地址
    			this.$store.commit('setSelectedInvoiceData',Object.assign(item));
    			console.log('发票',this.$store.state.selectedInvoiceData)
      		this.$router.back();
    		}
    	},
    	setDefault(item){
    		for(var i=0;i<this.data.length;i++){
    			this.data[i].isDefault=false;
    		}
    		item.isDefault=!item.isDefault;
    	},
    	newInvoice(){
      	this.$store.commit('setEidtInvoiceData',{});
      	this.$router.push({path:'/EditInvoice?isSubSelect='+this.$route.query.isSubSelect});
    	},
    	refresh() {
        this.$refs.listview.refresh()
      },
     /* scroll(scrollPos,maxY) {
        if (scrollPos.y > 30) {
          this.pullDownMsg='释放刷新';
        }
        if(scrollPos.y<= (maxY - 40)&&this.hasMore){
      		this.pullUpMsg='释放加载更多';
        }
      },
      scrollToEnd(){
      	if(this.hasMore){
      		this._getData();
      	}

      },
      scrollToTop(){
      	this.hasMore=true;
      	this.curPage=0;
        this._getData(true);
      },*/
      editInvoice(item){
      	this.$router.push({path:'/EditInvoice?invoiceId='+item.ci_id+'&isSubSelect='+this.$route.query.isSubSelect});
      },
      deleteInvoice(item){
      	var that=this;
      	this.$messagebox.confirm('确定删除这条数据？','温馨提示',{callback:function(type){
      		if(type=='confirm'){
      			that.$cHttp.post('cusinvoice/delete',{
              partner:that.$systemConfig.partner,
              apikey:that.$systemConfig.apikey,
              ci_id:item.ci_id
            }).then((res)=>{
              console.log(res)
              if(res.status&&res.status==1){
                that._getData();
              }else{
                that.$toast('删除失败')
              }
            }).catch((msg)=>{
              that.$toast(msg);
            })
      		}
      	}})
      },
      searchSub(keyWord){
      	this.keyWord=keyWord;
      	this.hasMore=true;
      	this.curPage=1;
        this._getData(true);
        this.$refs.listview.scrollTo(0,0)
      },
      _getData(clear){
        this.$cHttp.post('cusinvoice/index',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          page_pernum:this.pageSize,
          current_page:this.curPage
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            this.data=res.data.rows;
            if(this.$route.params.isSelect){
              var selectedId=this.$store.state.selectedInvoiceData.ci_id;
              for(var i=0;i<this.data.length;i++){
                if(this.data[i].ci_id==selectedId){
                  this.data[i].isSelected=true;
                }else{
                  this.data[i].isSelected=false;
                }
              }
            }
          }else{
            this.$toast('暂无数据')
          }
        }).catch((msg)=>{
          this.$toast(msg);
        })

      }
    },
    components:{
        Scroll,GoodsItem,SearchBlock
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.search-group-wapper{
		position: absolute;
    top:0;
    left:0;
    width: 100%;
	}
	.listview{
	  position: absolute;
	  width: 100%;
	  top:.61rem;;
		left:0;
		bottom:0;
	  overflow: hidden;
	}
	.list-wapper{
	  .query-list{
	    min-height: 100.3%;
	    .pullDown{
	      position: absolute;
	      top: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .pullUp{
	      position: absolute;
	      bottom: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .list-item{
	    	display: flex;
	    	align-items:center;
	    	padding: .1rem 0 0 .1rem;
		    border-bottom: 4px solid #eee;
		    box-sizing: border-box;
		    >.mint-checkbox-core{
		    	margin-top: -.1rem;
		    }
		    >div{
		    	flex: 1;
	    		position:relative;
	    		.invoice-type-icon{
	    			position:absolute;
	    			top:0;
	    			right:.1rem;
	    			width:.15rem;
	    			height:.15rem;
	    			padding:.02rem;
	    			line-height: .15rem;
	    			text-align: center;
	    			font-size:.12rem;
	    			color:#fff;
	    			border-radius: .04rem;
	    			background-color:$mainColor;
	    		}
	    		.invoice-info-item{
	    			padding-right:.2rem;
	    			display: flex;
	    			box-sizing: border-box;
	    			flex-direction: column;
	    			font-size: .15rem;
				    color: #333;
				    line-height: .2rem;
	    			.name{
              padding: .02rem 0;
              font-size: 0.12rem;
              color: #aaa;
	    			}
	    		}
		    }

		     .opr-bar{
		     	display: flex;
		     	align-items: center;
		     	padding: .08rem .1rem;
		     	padding-left: 0;
		     	font-size: .15rem;
		     	color: #333;
		     	.set-default-group{
		     		flex: 1;
		     		&.active{
		     			color: $mainColor;
		     		}
		     	}
		     	.opr-btns{
		     		.opr-btn{
		     			padding: .1rem .15rem;
		     			&.edit{
		     				background:url(../../assets/edit-icon.png) no-repeat right center;
		     				background-size: .18rem .18rem;
		     			}
		     			&.delete{
		     				background:url(../../assets/delete-icon.png) no-repeat right center;
		     				background-size: .18rem .18rem;
		     			}
		     		}
		     	}
		     }
		     .mint-checkbox-core{
					margin-right: .1rem;
					width: .15rem;
					height: .15rem;
					&.checked{
						background-color: $mainColor;
	    			border-color: $mainColor;
	    			&:after{
	    				width: 2px;
    					height: 6px;
	    				border-color: #fff;
	    				transform: rotate(45deg) scale(1);
	    			}
					}
				}
	    }
	  }
	}
</style>



// WEBPACK FOOTER //
// src/components/invoiceList/invoiceList.vue